import { safeParseToInt } from '@r-and-a-shared-ui/utils';

const isInMemoryCacheEnabled =
  process.env['NEXT_PUBLIC_IN_MEMORY_CACHE']?.toLowerCase() !== 'false';

const getTtl = (ttl: string | undefined, defaultTtl: number) =>
  isInMemoryCacheEnabled ? safeParseToInt(ttl) || defaultTtl : 0;

export const CacheConfig = Object.freeze({
  TTL: {
    AppRouterRevalidate: 300,
    ttlDelta: isInMemoryCacheEnabled
      ? safeParseToInt(process.env['NEXT_PUBLIC_CACHE_TTL_DELTA'] ?? '3')
      : 0,
    Default: isInMemoryCacheEnabled
      ? safeParseToInt(
          // eslint-disable-next-line no-undef
          process?.env?.['NEXT_PUBLIC_DEFAULT_CACHE_TTL'] ?? '600', // 10 minutes
        )
      : 0,
    PageElement: getTtl(process.env['NEXT_PUBLIC_PAGE_ELEMENT_CACHE_TTL'], 597),
    PageContent: getTtl(process.env['NEXT_PUBLIC_PAGE_CONTENT_CACHE_TTL'], 598),
    PageTemplate: getTtl(
      process.env['NEXT_PUBLIC_PAGE_TEMPLATE_CACHE_TTL'],
      599,
    ),
    Page: getTtl(process.env['NEXT_PUBLIC_PAGE_CACHE_TTL'], 600) || 1,
    ArticleAuthors: getTtl(
      process.env['NEXT_PUBLIC_ARTICLE_AUTHORS_CACHE_TTL'],
      600,
    ),
    Config: getTtl(process.env['NEXT_PUBLIC_CONFIG_CACHE_TTL'], 600),
    LatestArticles: getTtl(
      process.env['NEXT_PUBLIC_LATEST_ARTICLES_CACHE_TTL'],
      600,
    ),
    StaleWhileRevalidateTTL: isInMemoryCacheEnabled ? 59 : 0,
    VirtualWaitingRoom:
      safeParseToInt(process.env['VIRTUAL_WAITING_ROOM_CACHE_TTL_SEC']) || 600,
    ContinuationTokenValidation:
      safeParseToInt(
        process.env['CONTINUATION_TOKEN_VALIDATION_CACHE_TTL_SEC'],
      ) || 2,
  },
  keyPrefix: process?.env?.['CACHE_KEY_PREFIX'] ?? '',
  Hit: 'HIT',
  Miss: 'MISS',
  InMemoryCache:
    process.env['NEXT_PUBLIC_IN_MEMORY_CACHE']?.toLowerCase() !== 'false',
});
